module.exports = __webpack_public_path__ + "assets/img/img_2016.b2c15647.jpg";